import set from "lodash/set";
import get from "lodash/get";
import { produce } from 'immer';
import data from "./data";
import list from "./list";
import loading from "./loading";

import { GET_LIST, GET_ONE } from "../../dataFetchActions";
import { CRUD_CUSTOM } from "../../actions/dataActions/crudconstants";

const initialState = {};

const produceResource = produce((resource, action) => {
  const { type, id } = action.meta;
  const location = action.meta.location || "default";
  const componentId = action.meta.id || "default";

  if (type === GET_LIST) {
    const key = `${location}.${componentId}.list`;
    const _prev = get(resource, key, {});
    set(resource, key, list(_prev, action));
  } else if (type === GET_ONE) {
    const key = `loading.${id}`
    const _prev = get(resource, key, false);
    set(resource, key, loading(_prev, action));
  }

  resource.data = data(resource.data, action);
});

export default (previousState = initialState, action) => {
  if (!action || !action.meta || !action.meta.resource) {
    return previousState;
  } else if (action.meta.type === CRUD_CUSTOM) {
    return produce(previousState, (draft) => {
      console.log('producing custom', draft, action)
      const { resource, subResource } = action.meta;
      let key = subResource || resource;
      if (!draft[key]) draft[key] = {};
      if (!draft[key]._custom) draft[key]._custom = {};
      draft[key]._custom[action.customAction] = action.payload
    })
  } else {

    return produce(previousState, (draft) => {
      const { resource, subResource } = action.meta;

      draft[subResource || resource] = produceResource(draft[subResource || resource] ?? {}, action);
    });
  }
};